import React from 'react';

import FormikInput from "components/input/new/FormikInput";

function WsPasswordField(props) {
    return (
        <FormikInput
            name={'wsPassword'}
            label={'shippingMethods.form.field.wsPassword.label'}
            placeholder={'shippingMethods.form.field.wsPassword.placeholder'}
            required={true}
            type='password'
        />
    );
}

export default WsPasswordField;
